import ResetPrivacyPolicyButton from './reset-privacy-policy-button';
import Can from '../../common/guards/can';

const ContentEditorExtension = ({page, show}) => show && (
  <div className="mg-tb-20">
    {page === 'privacy-policy' && (
      <Can action="manage" subjectClass="PrivacyPolicy">
        <ResetPrivacyPolicyButton/>
      </Can>
    )}
  </div>
);

export default ContentEditorExtension;
